import * as React from 'react';
import Radium from 'radium';
import { connect } from 'react-redux';
import * as Tgcc from '../tgccGlobal';
import { ScreenDoor } from './ScreenDoor';

const overlayStyle: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
    padding: '20px'
};

const modalStyle: React.CSSProperties = {
    backgroundColor: 'white',
    borderRadius: '16px',
    boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
    maxWidth: '500px',
    width: '100%',
    maxHeight: '90vh',
    overflow: 'auto',
    position: 'relative',
    animation: 'slideIn 0.3s ease-out'
};

const headerStyle: React.CSSProperties = {
    background: 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)',
    color: 'white',
    padding: '24px',
    borderRadius: '16px 16px 0 0',
    textAlign: 'center',
    position: 'relative'
};

const successIconStyle: React.CSSProperties = {
    fontSize: '48px',
    marginBottom: '12px',
    display: 'block'
};

const titleStyle: React.CSSProperties = {
    fontSize: '24px',
    fontWeight: '600',
    margin: '0',
    fontFamily: 'Lulo, sans-serif'
};

const contentStyle: React.CSSProperties = {
    padding: '32px 24px',
    textAlign: 'center'
};

const messageStyle: React.CSSProperties = {
    fontSize: '16px',
    lineHeight: '1.6',
    color: '#333',
    marginBottom: '24px',
    fontFamily: 'Arial, sans-serif'
};

const buttonContainerStyle: React.CSSProperties = {
    display: 'flex',
    gap: '12px',
    justifyContent: 'center',
    marginTop: '24px'
};

const primaryButtonStyle: React.CSSProperties = {
    backgroundColor: '#4CAF50',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    padding: '12px 24px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontFamily: 'Lulo, sans-serif',
    minWidth: '120px'
};

const secondaryButtonStyle: React.CSSProperties = {
    backgroundColor: 'transparent',
    color: '#6c757d',
    border: '2px solid #e9ecef',
    borderRadius: '8px',
    padding: '12px 24px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontFamily: 'Lulo, sans-serif',
    minWidth: '120px'
};

const closeButtonStyle: React.CSSProperties = {
    position: 'absolute',
    top: '12px',
    right: '12px',
    background: 'rgba(255, 255, 255, 0.2)',
    border: 'none',
    borderRadius: '50%',
    width: '32px',
    height: '32px',
    color: 'white',
    fontSize: '18px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background 0.2s ease'
};

const keyPointsStyle: React.CSSProperties = {
    textAlign: 'left',
    margin: '16px 0'
};

const pointStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    margin: '8px 0',
    fontSize: '14px',
    color: '#555'
};

const bulletStyle: React.CSSProperties = {
    width: '6px',
    height: '6px',
    backgroundColor: '#4CAF50',
    borderRadius: '50%',
    marginRight: '12px',
    flexShrink: 0
};

export class ApprovalConfirmationProps extends Tgcc.BaseProps {
    onContinue?: () => void;
    onClose?: () => void;
}

class _ApprovalConfirmation extends React.Component<ApprovalConfirmationProps, any> {
    
    close = () => {
        this.props.dispatch({type: Tgcc.StateAction.DialogAction, payload: null});
    }
    
    handleContinue = () => {
        if (this.props.onContinue) {
            this.props.onContinue();
        }
        this.close();
    }

    handleOverlayClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            this.close();
        }
    }
    
    render(){
        return(
            <div style={overlayStyle} onClick={this.handleOverlayClick}>
                <div style={modalStyle}>
                    <div style={headerStyle}>
                        <button style={closeButtonStyle} onClick={this.close} title="Close">
                            ×
                        </button>
                        <span style={successIconStyle}>✓</span>
                        <h2 style={titleStyle}>Design Approved!</h2>
                    </div>
                    
                    <div style={contentStyle}>
                        <div style={messageStyle}>
                            Thank you for your design approval. Your account manager will contact you shortly to finalize order details including sizes, billing/shipping info, and production timeline.
                        </div>
                        
                        <div style={keyPointsStyle}>
                            <div style={pointStyle}>
                                <div style={bulletStyle}></div>
                                Normal production time is 5-7 business days
                            </div>
                            <div style={pointStyle}>
                                <div style={bulletStyle}></div>
                                Rush orders may incur additional fees
                            </div>
                            <div style={pointStyle}>
                                <div style={bulletStyle}></div>
                                You'll receive updates on your order status
                            </div>
                        </div>
                        
                        <div style={buttonContainerStyle}>
                            <button 
                                style={primaryButtonStyle} 
                                onClick={this.handleContinue}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = '#45a049';
                                    e.currentTarget.style.transform = 'translateY(-1px)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = '#4CAF50';
                                    e.currentTarget.style.transform = 'translateY(0)';
                                }}
                            >
                                Continue to Dashboard
                            </button>
                            <button 
                                style={secondaryButtonStyle}
                                onClick={this.close}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.borderColor = '#4CAF50';
                                    e.currentTarget.style.color = '#4CAF50';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.borderColor = '#e9ecef';
                                    e.currentTarget.style.color = '#6c757d';
                                }}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: Tgcc.GlobalState, ownState: any) => {
    return { state: state };
};

export const ApprovalConfirmation = connect(mapStateToProps)(Radium(_ApprovalConfirmation));
